import React, { useState, CSSProperties } from "react";
import "bootstrap/dist/css/bootstrap.css";
import BeatLoader from "react-spinners/ClipLoader";
import axios from "axios";
import "./Weather.css";

import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  let [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.mainCity);

  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "grey",
  };

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coords: response.data.coord,
      city: response.data.name,
      date: response.data.dt,
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
      visibility: response.data.visibility,
      cloud: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
    });

  }

  function searchAPI() {
    const apiKey = "f8e6a9e3d6fde87cb38868da460b1371";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function HandleSubmit(event) {
    event.preventDefault();
    searchAPI();
  }

  function HandleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={HandleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder=""
                className="form-control"
                onChange={HandleCityChange}
              />
            </div>
            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-secondary text-center"
              />
            </div>
          </div>
        </form>

        <WeatherInfo info={weatherData} />
        <WeatherForecast coordinates={weatherData.coords}/>
      </div>
    );
  } else {
    searchAPI();
    return (
      <div className="Weather">
        <BeatLoader color="#c6cecc" cssOverride={override} />
      </div>
    );
  }
}
